/**
 * The motion vocabulary shared by `Reveal` (one element) and `RevealGroup`
 * (a list that arrives in sequence). Both animate only `opacity` and
 * `transform`, so a reveal never leaves the compositor and can never trigger
 * layout (§52).
 */

/** Where the content travels in from. */
export type RevealDirection = 'up' | 'left' | 'right' | 'scale';

export const revealHiddenTransform: Record<RevealDirection, string> = {
  up: 'translate3d(0, 24px, 0)',
  left: 'translate3d(-24px, 0, 0)',
  right: 'translate3d(24px, 0, 0)',
  scale: 'scale(0.96)',
};

export const revealTransition =
  'opacity 600ms ease, transform 600ms cubic-bezier(0.22, 1, 0.36, 1)';
